import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="style-via-data"
export default class extends Controller {
  static values = {
    attribute: String,
  };

  static targets = ["element"];

  changeData(event) {
    this.elementTargets.forEach((element) => {
      element.dataset[this.attributeValue] = event.currentTarget === element;
    });
  }
}
